import { useRootStore } from './useRootStore';

export function useCookieConsentStore() {
  const { cookieConsentStore } = useRootStore();
  return cookieConsentStore;
}
